var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_383_80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF595E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.5,
    width: 41,
    height: 41,
    rx: 20.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3657 14C31.6627 14.0226 30.0373 14.7158 28.8421 15.9292C27.6469 17.1426 26.9783 18.7783 26.9815 20.4815C26.8843 23.1389 26.6736 26.1042 25.4097 27.919C29.7523 30.5602 33.463 30.2037 33.463 30.2037C33.463 30.2037 37.1736 30.5602 41.5162 27.919C40.1389 25.6991 39.8472 22.9769 39.9444 20.4815C39.9444 16.9005 37.044 14 33.463 14H33.3657ZM28.375 30.7222C23.7407 31.7106 20.5 34.0116 20.5 36.6852V43.1667H33.463L28.6019 36.6852H24.5509M33.463 43.1667L36.3472 31.5162C36.3472 31.5162 35.0833 31.8241 33.463 31.8241C31.8426 31.8241 30.5787 31.5162 30.5787 31.5162M33.463 43.1667H46.4259V36.6852C46.4259 34.0116 43.1852 31.7106 38.5509 30.7222L42.375 36.6852H38.3241L33.463 43.1667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_383_80",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_383_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_383_80",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_383_80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.926340f50d2d1176c63b5836912f3521.svg";
export { ForwardRef as ReactComponent };